module.exports = "<div id=\"overlay\" [ngClass]=\"isShow?'show':''\">\r\n    <div>\r\n        <div class=\"spinner-border text-danger\" style=\"width: 3rem; height: 3rem;\" role=\"status\">\r\n        </div>\r\n        <span class=\"sr-only text-white \" >Sending The Order ....</span>\r\n    </div>\r\n    \r\n   \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/QrMena/components/overlay-component/overlay.component.html
// module id = ./src/QrMena/components/overlay-component/overlay.component.html
// module chunks = main